<template>
<el-dialog title="选择供应商" width="80%" :append-to-body="true" :visible.sync="viewData.visible" :close-on-click-modal="false" v-loading="loading">
    <div class="user-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="供应商名称" prop="venderName">
                <el-input size="small" v-model="dataForm.venderName" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
<!--            <el-form-item label="项目经验" prop="venderExpierence">-->
<!--                <el-input size="small" v-model="dataForm.venderExpierence" placeholder="项目经验" clearable @blur="getDataList"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="主邮箱" prop="email">-->
<!--                <el-input size="small" v-model="dataForm.email" placeholder="主邮箱" clearable @blur="getDataList"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="联系人邮箱" prop="email2">-->
<!--                <el-input size="small" v-model="dataForm.email2" placeholder="联系人邮箱" clearable @blur="getDataList"></el-input>-->
<!--            </el-form-item>-->
            <!-- <el-form-item label="类型" prop="supplierLevel">
                <el-select v-model="dataForm.supplierLevel" placeholder="请选择" clearable>
                    <el-option v-for="item in SUPPLY_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="邮箱">
                <el-input size="small" v-model="dataForm.mail" placeholder="邮箱" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item class="fr">
                <el-button icon="el-icon-search" size="small" class="cla-user-search" @click="getDataList(ids)">查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" @current-change="currentChange" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" highlight-current-row style="width: 100%;" border @selection-change="selectionChangeHandle">
                <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="venderName" header-align="center" align="left" min-width="100" label="供应商名称">
                </el-table-column>
                <el-table-column prop="venderCode" header-align="center" align="left" min-width="100" label="供应商编码">
                </el-table-column>
                <el-table-column prop="venderLogin" header-align="center" align="left" width="150" label="用户名">
                </el-table-column>
<!--                <el-table-column prop="venderExpierence" header-align="center" align="left" min-width="100" label="项目经验">-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="email" header-align="center" align="left" min-width="100" label="主邮箱">-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="email2" header-align="center" align="left" min-width="100" label="联系人邮箱">-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="supplierLevel" header-align="center" align="center" width="100" label="类型">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{getSUPPLY_TYPE_VALUE(scope.row.supplierLevel)}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
            </el-pagination>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">

        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <!-- 询价中 -->
        <el-button size="small" type="primary" @click="confirm()">
            确认
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    USER_TYPE,
    SUPPLY_RFQ_STATUS_VALUE,
    SUPPLY_TYPE_VALUE,
    getSUPPLY_TYPE_VALUE,
    DIALOG_CLOSED_TYPE
} from '@/utils/const';
import {
    selectSupplierPage2
} from "@/controller/supplier";
import {
    createRfqSupplierBatch
} from "@/controller/rfq";
export default {
    data() {
        return {
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            dialogFormVisible: false,
            dataForm: {
                id: 0,
                venderName: '',
                email: '',
                email2: '',
                venderExpierence: '',
                supplierLevel: '1',
                rfqSupplierReplyStatus: 0,
                rfqId: '',
            },
            dataList: [],
            supplierList: [],
            ids: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            dataListLoading: false,
            dataListSelections: [],
            SUPPLY_RFQ_STATUS_VALUE: SUPPLY_RFQ_STATUS_VALUE,
            SUPPLY_TYPE_VALUE: SUPPLY_TYPE_VALUE,
            getSUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE
        }
    },
    mounted() {},
    activated() {
        this.getDataList()
    },
    methods: {
        open() {
            this.viewData.visible = true
            this.pageSize = 10
            this.pageIndex = 1
            this.getDataList()
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            console.log(this.currentRow, 'this.currentRow ====================')
            this.onClosed({
                option,
                sender: this,
                data: this.currentRow,
            });
            this.viewData.visible = false;
        },
        confirm() {
          //将选择的数据添加到零件列表
          console.log(this.currentRow, 'this.currentRow 11====================')
          this.$emit('refreshPartList', this.currentRow)
          this.viewData.visible = false;
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true,
                selectSupplierPage2({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    ...this.dataForm
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        // 新增
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id)
            })
        },
        // dataFormSubmit() {
        //     this.$refs['temp'].validate((valid) => {
        //         if (valid) {
        //             updatePassword(
        //                 {
        //                     'id': this.userId,
        //                     'password': this.temp.newPassword
        //                 }
        //             ).then(data => {
        //                 if (data && data.code === '00') {
        //                     this.$message({
        //                         message: '操作成功',
        //                         type: 'success',
        //                         duration: 1500,
        //                         onClose: () => {
        //                             this.getDataList()
        //                         }
        //                     })
        //                 } else {
        //                     this.$message.error(data.msg)
        //                 }
        //                 this.dialogFormVisible = false
        //             })
        //         }
        //     })
        // },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}

.fr {
    float: right;
}

.mt15 {
    margin-top: 15px;
}

.mb {
    margin-bottom: 15px;
}
</style>
